// NOTE: Do not use arrow functions, `this` must be bound to the `#SortBy` element.
document.querySelector('#SortBy').addEventListener('change', function() {
  let params = (new URL(document.location)).searchParams;
  params.set('sort_by', this.value);
  location.search = params.toString();
});

/*******************************************************************************
 * Sort tags numerically
 ******************************************************************************/
document.querySelectorAll('.js-sort-list').forEach(list => {
  [...list.children]
    .sort((a,b) => a.dataset.sortNum - b.dataset.sortNum)
    .forEach(node => list.appendChild(node));
});

/*******************************************************************************
 * Handle toggle button for Featured Colors
 ******************************************************************************/
/*
document.querySelector('#js-toggle-all-colors')?.addEventListener('click', (function() {
  // Determine view-mode using an indicator element's visibility as litmus test
  const isMobileView = (function() {
    const indicator = document.querySelector('#js-col-view--mobile-tab__filter');
    return () => (indicator.clientHeight !== 0);
  })();
  const isInViewport = function(el) {
    const bounding = el.getBoundingClientRect();
    return (bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth));
  };
  const heading = document.getElementById('js-colors');
  const colorList = document.querySelector('#js-color-list');

  return function() {
    this.classList.toggle('js-toggle-all-colors__all-visible');
    colorList.classList.toggle('js-color-list__all-visible');
    if (isMobileView() && !isInViewport(heading)) {
      heading.scrollIntoView();
    }
  }
})());
*/

/*******************************************************************************
 * Handle mobile toggle buttons for Filter and Sort dropdowns
 ******************************************************************************/
(function () {
  const filterButton = document.querySelector('#js-col-view--mobile-tab__filter');
  const filter = document.querySelector('#js-collection-filter');
  const sortButton = document.querySelector('#js-col-view--mobile-tab__sort');
  const sort = document.querySelector('#js-collection-sort');
  filterButton.addEventListener('click', function() {
    filter.classList.toggle('is-open');
    this.classList.toggle('col-view--mobile-tab__is-open');
    sort.classList.remove('is-open');
    sortButton.classList.remove('col-view--mobile-tab__is-open');
  });
  sortButton.addEventListener('click', function() {
    sort.classList.toggle('is-open');
    this.classList.toggle('col-view--mobile-tab__is-open');
    filter.classList.remove('is-open');
    filterButton.classList.remove('col-view--mobile-tab__is-open');
  });
})();


/*******************************************************************************
 * Handle collapsible sections in the mobile Filter dropdown
 ******************************************************************************/
(function() {
  const LOCAL_STORAGE_NAME = 'p4_collapse_filters';
  const COLLAPSE_CLASS = 'js-collection-filter-section__collapse';
  let collapse =
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_NAME)) ??
    ['crystals', 'crystal-shapes', 'crystal-colors', 'colors', 'width', 'series', 'tags'];
  // Initialize section collapses (but sections are always visible if it
  // contains an active tag.)
  document.querySelectorAll('.js-collection-filter-section').forEach(section => {
    const activeTagsCount = section.getElementsByClassName('col-view-link__active').length;
    if (activeTagsCount) {
      // Show active tag count and do not collapse section.
      section.querySelector('.js-collection-filter-heading-stats').textContent =
        `${activeTagsCount} applied`;
      return;
    }
    if (collapse.includes(section.dataset.section)) {
      section.classList.add(COLLAPSE_CLASS);
    }
  });

  // Handle toggle events and save visibility to localStorage.
  document.querySelectorAll('.js-collection-filter-heading').forEach(heading => {
    const section = heading.parentElement;
    const sectionName = section.dataset.section;
    const toggleCaret = heading.querySelector('.toggle-caret');
    heading.addEventListener('click', event => {
      // Clicks do nothing if not in mobile-view.
      const isMobile = window.getComputedStyle(toggleCaret).display === 'block';
      if (!isMobile) return;

      const isCollapse = section.classList.toggle(COLLAPSE_CLASS);
      if (isCollapse) {
        collapse.push(sectionName);
      } else {
        collapse.splice(collapse.indexOf(sectionName), 1);
      }
      localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify(collapse));
    });
  });
})();
